module.exports = __webpack_public_path__ + "img/songwriters-journal_B09MYVV8HN.f888bc3b.jpg";